import { render, staticRenderFns } from "./fleeingCount.vue?vue&type=template&id=e2dff672&scoped=true&"
import script from "./fleeingCount.vue?vue&type=script&lang=js&"
export * from "./fleeingCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2dff672",
  null
  
)

export default component.exports